import { render, staticRenderFns } from "./LawOfficer.vue?vue&type=template&id=cafa5452&"
import script from "./LawOfficer.vue?vue&type=script&lang=js&"
export * from "./LawOfficer.vue?vue&type=script&lang=js&"
import style0 from "./LawOfficer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports